export class Msg {
    constructor(public content: string, public sentBy: string) {}
}